module.exports = __webpack_public_path__ + "img/48-green.86fa6624.svg";